import { Search, X } from 'lucide-react';
import * as React from 'react';

import {
  DimeInputGroup,
  DimeInputGroupAddon,
  DimeInputGroupButton,
  DimeInputGroupInput,
} from './DimeInputGroup.js';

export type DimeSearchInputProps = Readonly<{
  value: string;
  onValueChange: (value: string) => void;
  placeholder: string;
  'aria-label'?: string;
  maxLength?: number;
  className?: string;
  clearable?: boolean;
  onClear?: () => void;
}>;

export function DimeSearchInput({
  value,
  onValueChange,
  placeholder,
  'aria-label': ariaLabel,
  maxLength,
  className,
  clearable = value !== '',
  onClear,
}: DimeSearchInputProps) {
  return (
    <DimeInputGroup className={className}>
      <DimeInputGroupAddon align="inline-start">
        <Search />
      </DimeInputGroupAddon>
      <DimeInputGroupInput
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        maxLength={maxLength}
        value={value}
        onChange={(event) => onValueChange(event.target.value)}
      />
      {clearable && (
        <DimeInputGroupAddon align="inline-end">
          <DimeInputGroupButton
            size="icon-xs"
            aria-label="Clear search"
            onClick={() => (onClear ? onClear() : onValueChange(''))}
          >
            <X />
          </DimeInputGroupButton>
        </DimeInputGroupAddon>
      )}
    </DimeInputGroup>
  );
}
